var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            { staticClass: "justify-content-md-center" },
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-card",
                    {
                      staticStyle: { "border-radius": "unset" },
                      attrs: {
                        "img-top": "",
                        title: "Complemento de Cadastro",
                        subTitle:
                          "Preencha as informações abaixo para complementar seu cadastro e da sua empresa."
                      }
                    },
                    [
                      _c(
                        "form-wizard",
                        {
                          ref: "wizard",
                          staticClass: "steps-transparent mb-3",
                          attrs: {
                            color: "#7367F0",
                            title: null,
                            subtitle: null,
                            "finish-button-text": "Finalizar",
                            "next-button-text": "Avançar",
                            "back-button-text": "Voltar"
                          },
                          on: {
                            "on-complete": _vm.formSubmitted,
                            "on-change": _vm.tabChange
                          }
                        },
                        [
                          _c(
                            "tab-content",
                            {
                              attrs: {
                                title: "Dados Pessoais",
                                icon: "feather icon-user"
                              }
                            },
                            [
                              _c("NaturalEntity", {
                                key: _vm.id,
                                ref: "naturalEntityRef",
                                attrs: {
                                  naturalEntityId: _vm.naturalEntityId,
                                  services: _vm.services,
                                  isComplement: true
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "tab-content",
                            {
                              attrs: {
                                title: "Pessoa Jurídica - Dados Básicos",
                                icon: "feather icon-home"
                              }
                            },
                            [
                              _c(
                                "b-alert",
                                { attrs: { variant: "warning", show: "" } },
                                [
                                  _c("div", { staticClass: "alert-body" }, [
                                    _vm._v(
                                      " Complemente os dados da Pessoa Jurídica e adicione um ou mais responsáveis. "
                                    )
                                  ])
                                ]
                              ),
                              _c("LegalEntityForm", {
                                ref: "legalEntityRef",
                                attrs: {
                                  legalEntityId: _vm.legal_entity_id,
                                  services: _vm.services,
                                  isComplement: true
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "tab-content",
                            {
                              attrs: {
                                title: "Pessoa Jurídica - Dados Complementares",
                                icon: "feather icon-home",
                                "before-change": _vm.beforeAddressPhone
                              }
                            },
                            [
                              _c(
                                "b-alert",
                                { attrs: { variant: "warning", show: "" } },
                                [
                                  _c("div", { staticClass: "alert-body" }, [
                                    _vm._v(
                                      " Adicione no mínimo um telefone e um endereço. "
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "b-card",
                                {
                                  staticClass: "border-secondary",
                                  attrs: {
                                    title: "Telefone",
                                    "sub-title":
                                      "Adicione na lista abaixo os telefones da pessoa jurídica"
                                  }
                                },
                                [
                                  _c("Phone", {
                                    ref: "phoneRef",
                                    attrs: { services: _vm.services }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-card",
                                {
                                  staticClass: "border-secondary",
                                  attrs: {
                                    title: "Endereço",
                                    "sub-title":
                                      "Adicione na lista abaixo os endereços da pessoa jurídica"
                                  }
                                },
                                [
                                  _c("Address", {
                                    ref: "addressRef",
                                    attrs: {
                                      services: _vm.services,
                                      addressTypeList: _vm.addressTypeList
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "tab-content",
                            {
                              attrs: {
                                title: "Unidade Organizacional",
                                icon: "feather icon-grid",
                                "before-change": _vm.beforeOrganizationalUnit
                              }
                            },
                            [
                              _c(
                                "b-alert",
                                { attrs: { variant: "warning", show: "" } },
                                [
                                  _c("div", { staticClass: "alert-body" }, [
                                    _vm._v(
                                      " Adicione uma unidade organizacional e vincule-a a um ou mais responsáveis. "
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "mt-2" },
                                [
                                  _c("OrganizationalUnitList", {
                                    ref: "organizationalUnitRef",
                                    attrs: {
                                      services: _vm.services,
                                      legalEntityId: _vm.legal_entity_id
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }